import axios from "axios";

const API_BASE_URL = "http://localhost:8080/api";

export const createBatch = async () => {
    const response = await axios.post(`${API_BASE_URL}/batches/create`);
    return response.data;
};

export const uploadFile = async (batchId, file, onUploadProgress) => {
    const formData = new FormData();
    formData.append("batchId", batchId);
    formData.append("file", file);

    return axios.post(`${API_BASE_URL}/files/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
    });
};

export const getBatchFiles = async (batchId) => {
    const response = await axios.get(`${API_BASE_URL}/files/batch/${batchId}`);
    return response.data;
};

export const downloadFile = (s3FileName) => {
    window.open(`${API_BASE_URL}/files/download/${s3FileName}`, "_blank");
};
